export default __webpack_public_path__ + "static/media/apple.62d0a8dd.svg";